<template lang="pug">
  v-app.image-two-column
    bar-and-nav(v-model="navDrawer" :links="links" mini)
      scrollactive(
        ref="scrollactive"
        @itemchanged="scrollItemChanged"
        :offset="textPortHeight / 2"
        :scroll-offset="textPortHeight / 3"
        highlight-first-item
        scroll-container-selector="#text"
      )
        nav-list(:items="items")
    v-main
      #text(:style="isLandscape ? landscapeTextStyle : portraitTextStyle")
        div(v-for="(item,index) in items" :key="item.slug" :id="item.slug" :small="selection != index")
          v-card(outlined :class="{inactive: selection != index}").ma-2
            v-card-title.title 
              h2.black--text.mb-0 {{item.title}}
            v-card-text.text
              vue-markdown {{item.content}}
      #chart(:style="isLandscape ? landscapeChartStyle : portraitChartStyle")
        v-img.d-flex.align-center(
          src="/arlington.jpg"
          style="height:100%"
          :aspect-ratio="isPortrait ? 1.6 : undefined"
        )
          embed-frame.mx-8(:url="items[selection].embed" :width="imageWidth" :y-offset="37")
</template>

<script>
import BarAndNav from '@/components/BarAndNav.vue'
import EmbedFrame from '@/components/EmbedFrame.vue'
import NavList from '@/components/NavList.vue'
import VueMarkdown from 'vue-markdown'

export default {
  props: ['items', 'links'],
  data: () => ({
    selection: 0,
    navDrawer: undefined
  }),
  components: {
    BarAndNav,
    EmbedFrame,
    NavList,
    VueMarkdown
  },
  computed: {
    slugs () {
      return this.items.map(item => item.slug)
    },
    isPortrait () {
      return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width
    },
    isLandscape () {
      return !this.isPortrait
    },
    landscapeTextStyle () {
      let left = this.$vuetify.breakpoint.lgAndUp ? 56 : 0
      let right = this.imageWidth
      return `position:fixed; top: 56px; left:${left}px; bottom:0; right:${right}px; overflow: scroll`
    },
    portraitTextStyle () {
      let width = this.$vuetify.breakpoint.mdAndDown ? this.$vuetify.breakpoint.width : this.$vuetify.breakpoint.width - 56
      let top = 56 + width / 1.6 - 8
      let left = this.$vuetify.breakpoint.lgAndUp ? 56 : 0
      return `position:fixed; bottom:0; left:${left}px; right:0; top:${top}px; overflow: scroll`
    },
    landscapeChartStyle () {
      let left = this.$vuetify.breakpoint.width - this.imageWidth
      return `position:fixed; top:56px; left:${left}px; right:0; bottom:0`
    },
    portraitChartStyle () {
      let left = this.$vuetify.breakpoint.lgAndUp ? 56 : 0
      return `position:fixed; top: 56px; left:${left}px; right:0`
    },
    textPortHeight () {
      if(this.isLandscape) {
        return this.$vuetify.breakpoint.height - 56
      } else {
        let width = this.$vuetify.breakpoint.mdAndDown ? this.$vuetify.breakpoint.width : this.$vuetify.breakpoint.width - 56
        let top = 56 + width / 1.6
        return this.$vuetify.breakpoint.height - top
      }
    },
    imageWidth () {
      if(this.isLandscape) {
        let widthBound = this.$vuetify.breakpoint.width * 2 / 3 - 64
        let heightBound = (this.$vuetify.breakpoint.height - 56 - 64) * 16 / 9
        return widthBound < heightBound ? widthBound : heightBound
      } else
        return this.$vuetify.breakpoint.width - 64
    }
  },
  methods: {
    scrollItemChanged (event, current) {
      if(current){
        let href = current.__vue__._props.href
        let slug = href.slice(1)
        this.selection = this.slugs.indexOf(slug)
      }
    },
    handleScroll (event) {
      //console.log(event.srcElement.scrollTop)
      let el = event.srcElement
      let last = this.slugs.length - 1
      if(this.selection != 0 && el.scrollTop == 0) {
        this.selection = 0
        this.$refs.scrollactive.$children[0].$children[0].$el.click()
      } else if(this.selection != last && el.scrollTop >= el.scrollHeight - el.offsetHeight) {
        this.selection = last
        this.$refs.scrollactive.$children[0].$children[last].$el.click()
      }
    }
  },
  mounted () {
    let el = document.getElementById('text')
    el.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    let el = document.getElementById('text')
    el.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="stylus">
.image-two-column
  .inactive
    opacity: 0.5
  .left
    position: absolute
    left: 0
    width: 35%
  .right
    position: fixed
    top: 56px
    right: 0
    bottom: 0
    width: 65%
  .top
    position: fixed
    top: 56px
    width: 100%
  .bottom
    position: fixed
    bottom: 0
    width: 100%
    height: 50%
    padding-top: 30px
    overflow: scroll
  .title
    overflow-wrap: normal
    word-break: normal
  .text
    font-size: 9pt
</style>